var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "vcenter" }, [
    _c(
      "form",
      {
        staticClass: "vcenter-form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit($event)
          }
        }
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("password.title")))]),
        _vm.errorMessage
          ? _c("b-message", { attrs: { type: "is-danger" } }, [
              _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")
            ])
          : _vm._e(),
        _c(
          "b-field",
          { attrs: { label: _vm.$t("password.field-password1") } },
          [
            _c("b-input", {
              attrs: { type: "password" },
              model: {
                value: _vm.password,
                callback: function($$v) {
                  _vm.password = $$v
                },
                expression: "password"
              }
            })
          ],
          1
        ),
        _c(
          "b-field",
          { attrs: { label: _vm.$t("password.field-password2") } },
          [
            _c("b-input", {
              attrs: { type: "password" },
              model: {
                value: _vm.password2,
                callback: function($$v) {
                  _vm.password2 = $$v
                },
                expression: "password2"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "form-buttons" }, [
          _c(
            "button",
            { staticClass: "button is-primary", attrs: { type: "submit" } },
            [_vm._v(_vm._s(_vm.$t("password.btn-valider")))]
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("router-link", { staticClass: "small", attrs: { to: "/" } }, [
                _vm._v(_vm._s(_vm.$t("password.btn-back")))
              ])
            ],
            1
          )
        ]),
        _c("b-loading", {
          attrs: { active: _vm.loading, "is-full-page": false }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }